module.exports = __webpack_public_path__ + "static/media/user-plus-solid.7465375f.svg";